import { render } from "./MicrophoneStatusIcon.vue?vue&type=template&id=1061af4e&ts=true"
import script from "./MicrophoneStatusIcon.vue?vue&type=script&lang=ts"
export * from "./MicrophoneStatusIcon.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__